import React, { useState, useEffect, useRef } from 'react';
import { Get_type_code_options } from '../Comun';
import '../FilterModal.css';

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onApplyFilters: (filters: {
        is_root_response: boolean;
        response: string | null;
        code: string | null;
        type: number | null;
        id_tag: number | null;
        id_provider: number | null;}) => void;
        
    onClearFilters: () => void;
    tags: { id: number; tag: string }[];
    providers: { id: number; name: string }[];
    currentFilters: {
        is_root_response: boolean;
        response: string | null;
        code: string | null;
        type: number | null;
        id_tag: number | null;
        id_provider: number | null;
    };
}

const FilterCodigoModal: React.FC<FilterModalProps> = ({
    isOpen,
    onClose,
    onApplyFilters,
    onClearFilters,
    tags,
    providers,
    currentFilters}) => 
{
    const [isRootResponse, setIsRootResponse] = useState<boolean>(currentFilters.is_root_response);
    const [response, setResponse] = useState<string | null>(currentFilters.response);
    const [code, setCode] = useState<string | null>(currentFilters.code);
    const [type, setType] = useState<number | null>(currentFilters.type);
    const [idTag, setIdTag] = useState<number | null>(currentFilters.id_tag);
    const [idProvider, setIdProvider] = useState<number | null>(currentFilters.id_provider);
    const modalRef = useRef<HTMLDivElement>(null); // Ref para el contenedor del modal  

    const typeOptions = Get_type_code_options(); // Obtener opciones de tipo de código

    //---------------------------------------------------------

    useEffect(() => 
    {
        if (isOpen) 
        {
            setIsRootResponse(currentFilters.is_root_response);
            setResponse(currentFilters.response);
            setCode(currentFilters.code);
            setType(currentFilters.type);
            setIdTag(currentFilters.id_tag);
            setIdProvider(currentFilters.id_provider);
        }
    }, [isOpen, currentFilters]);

    //-----------------------------------------------------------

    useEffect(() => 
    {
      // Función para manejar clics fuera del componente
      const handleClickOutside = (event: MouseEvent) => 
      {
        if (modalRef.current && !modalRef.current.contains(event.target as Node))
          onClose();
      };
  
      // Función para manejar presiones de teclas
      const handleEscPress = (event: KeyboardEvent) => 
      {
        if (event.key === 'Escape') 
          onClose();
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscPress);
  
      return () => 
      {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscPress);
      };
    }, [onClose]);  

    //---------------------------------------------------------

    const handleApplyFilters = () => 
    {
        onApplyFilters({
            is_root_response : isRootResponse,
            response,
            code,
            type,
            id_tag: idTag,
            id_provider: idProvider,
        });
        onClose(); // Cerrar el modal después de aplicar los filtros
    };

    //---------------------------------------------------------

    const handleClearFilters = () => 
    {
        setIsRootResponse(true);
        setResponse(null);
        setCode(null);
        setType(null);
        setIdTag(null);
        setIdProvider(null);
    };

    if (!isOpen) return null;

    //---------------------------------------------------------

    return (
        <div className="modal-overlay">
            <div className="modal-content" ref={modalRef}>
                <h2>Filtrar Códigos</h2>
                <form>
                    <div className="form-group">
                        <input
                            type="text"
                            id="code"
                            value={code || ''}
                            placeholder="--Todos los códigos--"
                            onChange={(e) => setCode(e.target.value || null)}
                        />
                    </div>
                    <div className="form-group">
                        <select
                            id="rootResponse"

                            value={isRootResponse ? 'startsWith' : 'contains'}
                            onChange={(e) => setIsRootResponse(e.target.value === 'startsWith')}
                        >
                            <option value="startsWith">Empieza con</option>
                            <option value="contains">Contiene</option>
                        </select>
                        <input
                            type="text"
                            id="response"
                            className="input-response"
                            value={response || ''}
                            placeholder="--Todas las respuestas--"
                            onChange={(e) => setResponse(e.target.value || null)}
                        />
                    </div>                    
                    <div className="form-group">
                        <select
                            id="type"
                            value={type !== null ? type : ''}
                            onChange={(e) => setType(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">--Todos los tipos--</option>
                            {typeOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <select
                            id="idTag"
                            value={idTag !== null ? idTag : ''}
                            onChange={(e) => setIdTag(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">--Todas las etiquetas--</option>
                            {tags.map(tag => (
                                <option key={tag.id} value={tag.id}>
                                    {tag.tag}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <select
                            id="idProvider"
                            value={idProvider !== null ? idProvider : ''}
                            onChange={(e) => setIdProvider(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">--Todos los proveedores--</option>
                            {providers.map(provider => (
                                <option key={provider.id} value={provider.id}>
                                    {provider.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-actions">
                        <div className="modal-actions-right">
                            <button type="button" onClick={handleApplyFilters}>Aplicar</button>
                            <button type="button" className="filter-button" onClick={onClose}>Cancelar</button>                            
                        </div>
                        <button type="button" onClick={handleClearFilters} className="delete-filter-button">
                            Borrar Filtros
                        </button>                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FilterCodigoModal;
